import { NavLink, Navigate, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut } from "lucide-react";

const NAV = [
  { to: "/admin", label: "Dashboard", end: true },
  { to: "/admin/enquiries", label: "Enquiries" },
  { to: "/admin/packages", label: "Packages" },
  { to: "/admin/projects", label: "Portfolio" },
  { to: "/admin/testimonials", label: "Testimonials" },
  { to: "/admin/faqs", label: "FAQs" },
  { to: "/admin/content", label: "Site Content" },
  { to: "/admin/availability", label: "Availability" },
];

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();
  const nav = useNavigate();

  if (loading) {
    return (
      <div className="min-h-screen bg-stone text-ink flex items-center justify-center" data-testid="admin-loading">
        <p className="label-mono opacity-60">Loading…</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen bg-stone text-ink flex" data-testid="admin-layout">
      <aside className="w-60 shrink-0 bg-ink text-ivory p-6 flex flex-col">
        <div>
          <img
            src="/brand/oereshaus-white.webp"
            alt="Oereshaus"
            className="w-32 h-auto object-contain"
          />
          <p className="label-mono mt-3 opacity-60">Admin</p>
        </div>
        <nav className="mt-10 flex-1 flex flex-col gap-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              className={({ isActive }) =>
                `label-mono text-sm py-3 px-2 border-l-2 transition-colors duration-300 ${
                  isActive ? "border-ivory text-ivory bg-white/5" : "border-transparent text-ivory/60 hover:text-ivory"
                }`
              }
              data-testid={`admin-nav-${n.label.replace(/\s+/g, "-").toLowerCase()}`}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="mt-6 border-t border-ivory/10 pt-4">
          <p className="label-mono opacity-60 text-xs">{user.email}</p>
          <button
            type="button"
            onClick={() => {
              logout();
              nav("/admin/login");
            }}
            className="mt-4 flex items-center gap-2 label-mono text-ivory/80 hover:text-ivory"
            data-testid="admin-logout"
          >
            <LogOut size={14} /> Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 p-8 md:p-12 bg-ivory overflow-x-auto">
        <Outlet />
      </main>
    </div>
  );
}
